//
//  DocumentationLegacyPageBlockRenderCode.ts
//  Pulsar Language
//
//  Created by Jiri Trecak.
//
// --- --- --- --- --- --- --- --- --- --- --- --- --- --- --- --- --- --- --- --- --- --- --- --- --- --- ---
// MARK: - Imports
import { Alignment } from "../../enums/SDKAlignment";
import { DocumentationLegacyPageBlock } from "../SDKDocumentationLegacyPageBlock";
import { btoa } from "abab";
var DocumentationLegacyPageBlockRenderCodeSandboxAlignment;
(function (DocumentationLegacyPageBlockRenderCodeSandboxAlignment) {
    DocumentationLegacyPageBlockRenderCodeSandboxAlignment["start"] = "start";
    DocumentationLegacyPageBlockRenderCodeSandboxAlignment["center"] = "center";
    DocumentationLegacyPageBlockRenderCodeSandboxAlignment["end"] = "end";
})(DocumentationLegacyPageBlockRenderCodeSandboxAlignment || (DocumentationLegacyPageBlockRenderCodeSandboxAlignment = {}));
var DocumentationLegacyPageBlockRenderCodeEnvironmentType;
(function (DocumentationLegacyPageBlockRenderCodeEnvironmentType) {
    DocumentationLegacyPageBlockRenderCodeEnvironmentType["react"] = "react";
})(DocumentationLegacyPageBlockRenderCodeEnvironmentType || (DocumentationLegacyPageBlockRenderCodeEnvironmentType = {}));
// --- --- --- --- --- --- --- --- --- --- --- --- --- --- --- --- --- --- --- --- --- --- --- --- --- --- ---
// MARK: -  Object Definition
export class DocumentationLegacyPageBlockRenderCode extends DocumentationLegacyPageBlock {
    // --- --- --- --- --- --- --- --- --- --- --- --- --- --- --- --- --- --- --- --- --- --- --- --- --- ---
    // MARK: - Constructor
    constructor(model, children, configuration) {
        var _a, _b, _c, _d;
        super(model, children);
        this.alignment = model.alignment;
        this.backgroundColor = (_b = (_a = model.backgroundColor) === null || _a === void 0 ? void 0 : _a.value) !== null && _b !== void 0 ? _b : null;
        this.showCode = model.renderCodeProperties.showCode;
        this.height = (_d = (_c = model.size) === null || _c === void 0 ? void 0 : _c.height) !== null && _d !== void 0 ? _d : null;
        this.code = model.text.spans.map((s) => s.text).join("");
        // @ts-expect-error TS(2322): Type 'string | null' is not assignable to type 'st... Remove this comment to see the full error message
        this.packageJSON = configuration.packageJson;
        this.sandboxData = this.encodeSandboxData(configuration);
        this.sandboxType =
            DocumentationLegacyPageBlockRenderCodeEnvironmentType.react;
    }
    // --- --- --- --- --- --- --- --- --- --- --- --- --- --- --- --- --- --- --- --- --- --- --- --- --- ---
    // MARK: - Sandbox data encoding
    encodeSandboxData(configuration) {
        var _a, _b;
        let localAlignment;
        switch (this.alignment) {
            case Alignment.center:
                localAlignment =
                    DocumentationLegacyPageBlockRenderCodeSandboxAlignment.center;
                break;
            default:
                localAlignment =
                    DocumentationLegacyPageBlockRenderCodeSandboxAlignment.start;
                break;
        }
        const definition = {
            type: DocumentationLegacyPageBlockRenderCodeEnvironmentType.react,
            code: this.code,
            // @ts-expect-error TS(2322): Type 'string | null' is not assignable to type 'st... Remove this comment to see the full error message
            packageJSON: configuration.packageJson,
            visual: {
                // @ts-expect-error TS(2322): Type 'number | null' is not assignable to type 'nu... Remove this comment to see the full error message
                forcedHeight: this.height,
                horizontalAlignment: localAlignment,
                verticalAlignment: DocumentationLegacyPageBlockRenderCodeSandboxAlignment.center,
                // @ts-expect-error TS(2322): Type 'string | null' is not assignable to type 'st... Remove this comment to see the full error message
                backgroundHex: (_a = this.backgroundColor) !== null && _a !== void 0 ? _a : null,
            },
            registry: (_b = configuration.npmRegistry) !== null && _b !== void 0 ? _b : null,
        };
        // @ts-expect-error TS(2322): Type 'string | null' is not assignable to type 'st... Remove this comment to see the full error message
        return this.btoaUnicode(JSON.stringify(definition));
    }
    // --- --- --- --- --- --- --- --- --- --- --- --- --- --- --- --- --- --- --- --- --- --- --- --- --- --- ---
    // MARK: - Data decoding unicode support
    // Encoding UTF8 ⇢ base64
    btoaUnicode(str) {
        return btoa(
        // TODO:fix-sdk-eslint
        // eslint-disable-next-line @typescript-eslint/no-unsafe-argument
        encodeURIComponent(str).replace(/%([0-9A-F]{2})/g, function convert(match, p1) {
            // TODO:fix-sdk-eslint
            // eslint-disable-next-line @typescript-eslint/no-unsafe-argument
            return String.fromCharCode(parseInt(p1, 16));
        }));
    }
    // Decoding base64 ⇢ UTF8
    atobUnicode(str) {
        return decodeURIComponent(Array.prototype.map // TODO:fix-sdk-eslint
            // eslint-disable-next-line @typescript-eslint/no-unsafe-argument
            .call(atob(str), function convert(c) {
            // TODO:fix-sdk-eslint
            // eslint-disable-next-line @typescript-eslint/no-unsafe-member-access, @typescript-eslint/no-unsafe-call
            return `%${`00${c.charCodeAt(0).toString(16)}`.slice(-2)}`;
        })
            .join(""));
    }
}
